/* ============================================================================
   Inherit — collection-card "fit cue"
   ----------------------------------------------------------------------------
   Adds a small badge under each collection product card title:

         {Model value} - {Fit value}      e.g.  "True to Size - Semi-Fitted"

   reading the Model | and Fit | rows from the product DESCRIPTION (body HTML)
   via /products/{handle}.js. Products without that info are left unchanged.

   This was previously injected via Intelligems; it now ships in the theme.
   Loaded from layout/theme.liquid as:
       <script src="{{ 'ih-fit-cue.js' | asset_url }}" defer="defer"></script>

   DEBUG: set DEBUG = true below to log how many cards were found.
   ========================================================================== */
(function () {
  'use strict';

  var DEBUG = false;

  var CONFIG = {
    // tried in order; first selector that matches wins. If none match, the
    // script falls back to finding cards via their /products/ link.
    cardSelectors: [
      '.card-wrapper.product-card-wrapper',
      '.card-wrapper',
      'li.grid__item',
      '.grid__item',
      '.card'
    ],
    titleSelectors: ['.card__heading', '.card-information__text', 'h3', 'h2'],
    productLinkSelector: 'a[href*="/products/"]',
    modelLabel: 'Model',   // first part of the badge
    fitLabel: 'Fit',       // second part of the badge
    separator: ' - ',      // "True to Size - Semi-Fitted"
    badgeClass: 'ih-fit-cue',
    cachePrefix: 'ihFitCue:',
    onlyOnCollections: true
  };

  function log() { if (DEBUG) try { console.log.apply(console, ['[ih-fit-cue]'].concat([].slice.call(arguments))); } catch (e) {} }

  if (CONFIG.onlyOnCollections &&
      location.pathname.indexOf('/collections') === -1 &&
      !document.querySelector(CONFIG.cardSelectors[0])) {
    log('not a collection page; exiting'); return;
  }

  /* ---- styling (brand tan chip) ----------------------------------------- */
  function injectStyles() {
    if (document.getElementById('ih-fit-cue-style')) return;
    var css =
      '.' + CONFIG.badgeClass + '{display:inline-flex;align-items:center;gap:5px;' +
        'width:fit-content;margin:4px 0 2px;padding:3px 7px;border-radius:3px;' +
        'background:#f4efe2;color:#8a7636;font-size:11px;line-height:1.3;' +
        'letter-spacing:.01em;font-family:inherit;}' +
      '.' + CONFIG.badgeClass + ' svg{width:12px;height:12px;flex:0 0 auto;}';
    var el = document.createElement('style');
    el.id = 'ih-fit-cue-style';
    el.textContent = css;
    (document.head || document.documentElement).appendChild(el);
  }

  var RULER_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>';

  /* ---- find candidate cards (tolerant of theme differences) ------------- */
  function collectCards() {
    for (var i = 0; i < CONFIG.cardSelectors.length; i++) {
      var found = document.querySelectorAll(CONFIG.cardSelectors[i]);
      if (found.length) { log('cards via', CONFIG.cardSelectors[i], found.length); return [].slice.call(found); }
    }
    // fallback: derive a card from each product link
    var cards = [], seen = [];
    document.querySelectorAll(CONFIG.productLinkSelector).forEach(function (a) {
      var card = a.closest('.card-wrapper, li.grid__item, .grid__item, .card') || a.parentElement;
      if (card && seen.indexOf(card) === -1) { seen.push(card); cards.push(card); }
    });
    log('cards via product-link fallback', cards.length);
    return cards;
  }

  // pick the product-title link the shopper actually SEES (cards often carry a
  // hidden desktop/mobile duplicate; attaching to the hidden one = no visible badge)
  function visibleTitleLink(card) {
    var links = card.querySelectorAll(CONFIG.productLinkSelector);
    var i, a;
    for (i = 0; i < links.length; i++) {
      a = links[i];
      if ((a.textContent || '').trim() && a.offsetParent !== null &&
          a.getBoundingClientRect().height > 0) return a;
    }
    for (i = 0; i < links.length; i++) {            // fallback: any link with text
      if ((links[i].textContent || '').trim()) return links[i];
    }
    return links[0] || null;
  }

  /* ---- parse Model | X and Fit | Y from the description ----------------- */
  var KNOWN = ['Fit','Length','Stretch','Model','Product Details','Style','Color',
               'Care','Material','Fabric','Lining','Closure','Sizing Tips'];
  function clip(value) {
    var idx = -1;
    for (var i = 0; i < KNOWN.length; i++) {
      var re = new RegExp('\\s+' + KNOWN[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[|:]', 'i');
      var m = value.match(re);
      if (m && (idx === -1 || m.index < idx)) idx = m.index;
    }
    return idx === -1 ? value : value.slice(0, idx);
  }
  function normalize(str) { return (str || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function isTrueToSize(str) { return /true\s*[- ]?\s*to\s*[- ]?\s*size/i.test(str || ''); }
  // Pick the real silhouette descriptor out of a Fit value.
  // The Fit row may list several parts (e.g. "True to size, Loose fit"): we skip the
  // generic "true to size" piece and any part that just restates Model, and keep the
  // first meaningful descriptor. Returns null if nothing meaningful remains.
  //   "True to size, Loose fit"                      -> "Loose fit"
  //   "Semi-Fitted" / "Oversized Fit"                -> kept as-is
  //   "True-to-size fit with flexible smocked waist" -> null (only restates true-to-size)
  function cleanFit(fit, model) {
    if (!fit) return null;
    var items = fit.split(/\s*[,/]\s*|\s+and\s+/i);
    for (var i = 0; i < items.length; i++) {
      var it = items[i]
        .replace(/\s+fit\s+with\b[\s\S]*$/i, '')  // "X fit with ..." -> "X"
        .replace(/\s+with\b[\s\S]*$/i, '')          // "X with ..."     -> "X"
        .replace(/[.;:][\s\S]*$/, '')                 // drop trailing . ; : clause
        .trim();
      if (!it) continue;
      if (isTrueToSize(it)) continue;                  // skip the generic sizing note
      if (model) {                                     // skip anything that restates Model
        var ni = normalize(it), nm = normalize(model);
        if (ni && nm && (ni === nm || ni.indexOf(nm) === 0 || nm.indexOf(ni) === 0)) continue;
      }
      return it;                                        // first meaningful descriptor wins
    }
    return null;
  }

  function parseCue(descriptionHtml) {
    // turn <br> and block-close tags into real line breaks BEFORE reading text,
    // so each "Label | value" row is its own line (the rows are <br>-separated)
    var html = (descriptionHtml || '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(li|p|div|h[1-6]|tr)>/gi, '\n');
    var box = document.createElement('div');
    box.innerHTML = html;
    var lines = (box.textContent || '').split(/\n+/)
      .map(function (s) { return s.replace(/\s+/g, ' ').trim(); })
      .filter(Boolean);
    function valueFor(label) {
      var re = new RegExp('^' + label + '\\s*[|:]\\s*(.+)$', 'i');
      for (var i = 0; i < lines.length; i++) {
        var m = lines[i].match(re);
        if (m) return clip(m[1]).trim();
      }
      return null;
    }
    var model = valueFor(CONFIG.modelLabel);
    var fit = cleanFit(valueFor(CONFIG.fitLabel), model);
    var parts = [];
    if (model) parts.push(model);
    if (fit) parts.push(fit);
    return parts.length ? parts.join(CONFIG.separator) : null;
  }

  /* ---- fetch description once per handle, cache for the session --------- */
  var inFlight = {};
  function getCue(handle) {
    return new Promise(function (resolve) {
      var key = CONFIG.cachePrefix + handle;
      try { var c = sessionStorage.getItem(key); if (c !== null) { resolve(c === '' ? null : c); return; } } catch (e) {}
      if (inFlight[handle]) { inFlight[handle].push(resolve); return; }
      inFlight[handle] = [resolve];
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var cue = p ? parseCue(p.description) : null;
          try { sessionStorage.setItem(key, cue || ''); } catch (e) {}
          (inFlight[handle] || []).forEach(function (fn) { fn(cue); }); delete inFlight[handle];
        })
        .catch(function () { (inFlight[handle] || []).forEach(function (fn) { fn(null); }); delete inFlight[handle]; });
    });
  }

  /* ---- inject badge into one card --------------------------------------- */
  function decorate(card) {
    if (card.getAttribute('data-ih-fit')) return;
    var link = visibleTitleLink(card);
    if (!link) { card.setAttribute('data-ih-fit', 'done'); return; }
    var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    var handle = m ? m[1] : null;
    if (!handle) { card.setAttribute('data-ih-fit', 'done'); return; }
    card.setAttribute('data-ih-fit', 'pending');
    getCue(handle).then(function (cue) {
      card.setAttribute('data-ih-fit', 'done');
      if (!cue) { log('no cue for', handle); return; }
      if (card.querySelector('.' + CONFIG.badgeClass)) return;
      var anchor = link.closest('h1,h2,h3,.card__heading') || link;
      var badge = document.createElement('span');
      badge.className = CONFIG.badgeClass;
      badge.innerHTML = RULER_SVG + '<span></span>';
      badge.querySelector('span').textContent = cue;
      anchor.insertAdjacentElement('afterend', badge);
      log('badge added for', handle, '->', cue);
    });
  }

  /* ---- lazy-load via IntersectionObserver ------------------------------- */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); decorate(en.target); } });
      }, { rootMargin: '200px' })
    : null;

  function scan() {
    try {
      var cards = collectCards();
      cards.forEach(function (card) {
        if (card.getAttribute && card.getAttribute('data-ih-fit')) return;
        if (io) io.observe(card); else decorate(card);
      });
    } catch (e) { log('scan error', e); }
  }

  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); });

  function start() { injectStyles(); scan(); mo.observe(document.body, { childList: true, subtree: true }); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
